import { store } from "@/store/store";

export default (functionContext) => {
    let { data, ctx, pixelRatio ,initialWidth,initialHeight} = functionContext;

    //64个柱子
    let point_count = getPointCount();
    let percent = initialHeight / 255;
    let increase = initialWidth / point_count;

    let thickness = 2;
    ctx.lineWidth = thickness* pixelRatio;
    ctx.strokeStyle = store.state.playing?store.getters.btnSkinColor:'#cccccc';

    for (let point = 1; point <= point_count; point++) {
        let p = data[point]; //get value
        p *= percent;

        let x = increase * point;

        ctx.moveTo(getSharpPixel(thickness, x,pixelRatio), getSharpPixel(thickness, initialHeight,pixelRatio));
        ctx.lineTo(getSharpPixel(thickness, x,pixelRatio), getSharpPixel(thickness, initialHeight - p,pixelRatio));

        ctx.stroke();

        ctx.beginPath();
    }

}

function getPointCount(){
    return window.innerWidth / 6;
}

function getSharpPixel(thickness, pos,pixelRatio) {

    if (thickness % 2 === 0) {
        return pos;
    }
    return pos + pixelRatio / 2;

}
